package com.eladfinish.bible.contest.features.share

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.copied_to_clipboard
import com.eladfinish.bible.contest.data.common.MyClipboardManager
import com.eladfinish.bible.contest.data.common.stringResolver.WebStrings
import com.eladfinish.bible.contest.ui.utils.showBrowserToast
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.desc.Resource
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.Promise
import kotlin.js.json

/**
 * Opens the browser's share sheet (Web Share API). Browsers without one — Firefox, and Chrome on
 * Linux — get the text copied to the clipboard instead, with a short notice saying so.
 */
class WebShareLauncher(
    private val clipboardManager: MyClipboardManager,
) : ShareLauncher {

    override suspend fun shareText(text: String, stringResource: StringResource?) {
        val navigator = window.navigator.asDynamic()
        if (navigator.share == null) {
            copyInstead(text)
            return
        }

        val data = json("text" to text)
        stringResource
            ?.let { WebStrings.resolveOrNull(StringDesc.Resource(it)) }
            ?.let { data["title"] = it }

        try {
            navigator.share(data).unsafeCast<Promise<Unit>>().await()
        } catch (t: Throwable) {
            // AbortError is the user closing the share sheet: nothing to fall back to.
            if (t.asDynamic().name != "AbortError") {
                copyInstead(text)
            }
        }
    }

    private fun copyInstead(text: String) {
        if (clipboardManager.copyToClipboard(text)) {
            showBrowserToast(WebStrings.resolveOrEmpty(StringDesc.Resource(SharedRes.strings.copied_to_clipboard)))
        }
    }
}
